// Firestore <-> live grading config glue. Keeps src/utils/gradingDefaults cache
// in sync with config/grading so tameProofColor (preview + reference) reflects
// saved tuning instantly, and lets an admin UI write new values with no deploy.
import { db } from '../firebaseConfig';
import { GRADING_DEFAULTS, setGradingConfig } from '../utils/gradingDefaults';

const DOC = db.collection('config').doc('grading');

// Live subscription — call once at app start. Returns the unsubscribe fn.
export function startGradingConfigSync() {
  return DOC.onSnapshot(
    (snap) => { setGradingConfig(snap.exists ? snap.data() : null); },
    () => { /* offline / perms — keep last good / defaults */ },
  );
}

export async function saveGradingConfig(next) {
  await DOC.set(next, { merge: true });
}

export { GRADING_DEFAULTS };
